<template>
  <div class="myclients">
    <div class="header">
      <van-row style="width: 100%" class="tac">
        <van-col span="8">
          <div class="num">{{ msg.todayVisitors }}</div>
          <div class="name">今日访客</div>
        </van-col>
        <van-col span="8">
          <div class="num">{{ msg.historyVisitors }}</div>
          <div class="name">历史访客</div>
        </van-col>
        <van-col span="8">
          <div class="num">{{ msg.readingQuantity }}</div>
          <div class="name">阅读量</div>
        </van-col>
        <!-- <van-col span="6">
          <div class="num">{{ msg.shareTimes }}</div>
          <div class="name">分享次数</div>
        </van-col> -->
      </van-row>
    </div>
    <div class="block">
      <van-dropdown-menu style="width: 33%; box-shadow: none">
        <van-dropdown-item
          v-model="value1"
          :options="option1"
          @change="change"
        />
      </van-dropdown-menu>
      <!-- <van-divider class="divider" /> -->
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-empty description="您还没有客户~" v-if="list.length == 0" />
        <van-cell
          v-for="(item, index) in list"
          :key="index"
          :border="false"
          v-else
        >
          <van-divider class="line" />
          <div class="client">
            <div class="flex aic">
              <!-- <img class="avater" :src="item.avatarPath" alt="" /> -->
              <van-image
                :src="item.avatarPath | getavatar"
                class="avater"
                round
              >
                <template v-slot:error>
                  <img
                    src="../../assets/img/avater.png"
                    class="avater"
                    style="margin: 0"
                  />
                </template>
              </van-image>
              <div class="info">
                <div class="flex aic jc-sb">
                  <div class="flex aic">
                    <div class="f18 f1010 mr-10 w220 van-ellipsis">
                      {{ item.nickname }}
                    </div>
                    <img
                      v-if="item.sex != '0'"
                      :src="
                        item.sex == '2'
                          ? require('../../assets/img/client/f.png')
                          : require('../../assets/img/client/m.png')
                      "
                      class="sex"
                      alt=""
                    />
                  </div>
                  <div class="detailbtn fcc" @click="todetail(item.id)">
                    详情 <van-icon name="arrow" />
                  </div>
                </div>
                <div class="flex f12 mt-10 lh18" style="color: #505559">
                  <div>
                    访问：<span style="color: #0b6e69"
                      >{{ item.frequency }}次</span
                    >
                  </div>
                  <div class="ml-5 mr-5">|</div>
                  <div>最后访问：{{ item.lastTime.split(" ")[0] }}</div>
                </div>
                <div
                  style="color: #505559; text-align: left"
                  class="f12 lh18 van-ellipsis mt-5"
                >
                  {{ item.title }}
                </div>
              </div>
            </div>
          </div>
        </van-cell>
      </van-list>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Vue from "vue";
import { Col, Row } from "vant";
import { analysis, mycustomer, customer } from "../../api/clients";
import Footer from "@/components/Newfooter";
Vue.use(Col);
Vue.use(Row);
export default {
  components: {
    Footer,
  },
  data() {
    return {
      value1: "id,desc",
      option1: [{ text: "默认排序", value: "id,desc" }],
      list: [],
      msg: "",
      finished: false,
      loading: false,
      page: 0,
    };
  },
  methods: {
    // 去详情
    todetail(id) {
      this.$router.push({ path: "/clientdetail", query: { id } });
    },
    // 客户列表
    getclients() {
      let data = {
        page: this.page,
        size: 10,
        sort: this.value1,
      };
      if (this.finished) return;
      mycustomer(data).then((res) => {
        console.log(res);
        if (res.content.length > 0) {
          this.page++;
          res.content.map((item) => this.clientdetail(item.customerId));
        } else {
          this.finished = true;
        }
        this.loading = false;
      });
    },
    // 、客户详情
    clientdetail(id) {
      customer(id).then((res) => {
        this.list.push(res);
      });
    },
    // 访问信息
    getanalysis() {
      analysis().then((res) => {
        console.log(res);
        this.msg = res;
      });
    },
    onLoad() {
      this.getclients();
    },
    change() {
      console.log(1);
    },
  },
  mounted() {
    // this.getclients();
    this.getanalysis();
  },
};
</script>
<style lang="less" >
.myclients {
  width: 100%;
  .van-cell {
    // padding: 0;
  }
  .header {
    width: 100%;
    height: 138px;
    background-image: url("../../assets/img/card/bj.png");
    background-size: 100% 100%;
    .num {
      color: rgba(255, 255, 255, 100);
      font-size: 21px;
      text-align: center;
      font-family: SourceHanSansSC-regular;
      margin-top: 33px;
      line-height: 31px;
    }
    .name {
      color: rgba(255, 255, 255, 100);
      font-size: 12px;
      // text-align: left;
      font-family: SourceHanSansSC-regular;
      line-height: 18px;
    }
  }
  .block {
    width: 358px;
    border-radius: 3px;
    text-align: center;
    border: 1px solid rgba(255, 255, 255, 100);
    margin: 11px auto;
    background: #fff;
    .van-dropdown-menu__bar {
      box-shadow: none;
    }
    .client {
      // padding: 19px 12px 22px 15px;
      .avater {
        width: 63px;
        height: 63px;
        border-radius: 3px;
        margin-right: 22px;
      }
      .info {
        width: 244px;
      }
      .detailbtn {
        width: 54px;
        height: 21px;
        line-height: 20px;
        border-radius: 11px;
        color: rgba(153, 159, 164, 100);
        font-size: 11px;
        text-align: center;
        font-family: Roboto;
        padding-left: 5px;
        border: 1px solid rgba(187, 187, 187, 100);
      }
      .sex {
        width: 20px;
        height: 20px;
      }
      .lh18 {
        line-height: 18px;
      }
    }
  }
  .divider {
    margin: 0 !important;
    margin-left: 15px !important;
    margin-right: 12px !important;
  }
  .van-dropdown-menu__title {
    margin-left: -20px;
    color: #999fa4;
    padding-right: 13px;
  }
  .w220 {
    width: 140px;
  }
}
</style>